module.exports = __webpack_public_path__ + "img/gafas-1.a0b77fc4.png";